'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _envInfo = require('./envInfo');

var HUBSPOT_DOMAIN = 'hubspot' + _envInfo.domainSuffix + '.com';
var SIDEKICK_DOMAIN = 'getsidekick' + _envInfo.domainSuffix + '.com';

exports.default = {
  HUBSPOT_API: 'app.' + HUBSPOT_DOMAIN,
  HUBSPOT_LOGIN: 'app.' + HUBSPOT_DOMAIN + '/login',
  SIDEKICK_API: 'api.' + SIDEKICK_DOMAIN,
  SIDEKICK_GAE_API: 'app.' + SIDEKICK_DOMAIN
};
module.exports = exports['default'];